<script setup>
import { computed } from 'vue'
import Icon from '@/Components/UI/Icon.vue'

const props = defineProps({
  modelValue: { type: [String, Number, null], default: '' },
  options: { type: Array, required: true }, // [{ value, label }]
  placeholder: { type: String, default: '' },
  error: { type: String, default: '' },
  hint: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: '' },
})
defineEmits(['update:modelValue'])
const hasError = computed(() => !!props.error)
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="relative">
      <select
        :id="id"
        :value="modelValue"
        :disabled="disabled"
        :aria-invalid="hasError || undefined"
        :class="[
          'w-full h-9 pl-3 pr-8 text-sm bg-[color:var(--surface)] text-[color:var(--ink)]',
          'rounded-[var(--radius-input)] border appearance-none transition-colors',
          'focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--accent)]',
          hasError ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)] focus:border-[color:var(--accent)]',
          disabled && 'opacity-50 cursor-not-allowed',
        ]"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
        <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
      <Icon name="chev-d" :size="16" class="absolute right-2.5 top-1/2 -translate-y-1/2 text-[color:var(--muted)] pointer-events-none" />
    </div>
    <p v-if="hasError" class="text-xs text-[color:var(--danger)]">{{ error }}</p>
    <p v-else-if="hint" class="text-xs text-[color:var(--muted)]">{{ hint }}</p>
  </div>
</template>
